import { styled } from "../../../../styles";

export const PanelStack = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  width: "100%",
});

/** Read-only list of the hospital's wards, shown for hospital-wide access. */
export const WardChipList = styled("ul", {
  display: "flex",
  flexWrap: "wrap",
  gap: "6px",
  listStyle: "none",
  margin: 0,
  padding: 0,
});

export const WardChip = styled("li", {
  padding: "4px 10px",
  borderRadius: "999px",
  backgroundColor: "$gray-20",
  color: "$gray-80",
  fontSize: "12px",
  fontFamily: "$openSans",
});

export const HistoryTabPanel = styled("div", {
  paddingTop: "4px",
});

// ModalBodyText moved to AdminPage.styles.ts (EN-5169): this file is
// star-exported from shared/index.ts, so a second definition of the same
// name there is a build error, not a shadow.

/**
 * Left side of a section's action row: the account-state note that explains
 * why Re-activate is or isn't available.
 */
export const ActionNote = styled("span", {
  marginRight: "auto",
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "12px",
  fontFamily: "$openSans",
  color: "$gray-60",
});
